<template>
    <div class="container">
        <div class="section">
            <img class="header" src="https://s21.lgstatic.com/growth/activity/20220602/1654160496331.png" alt="">
        </div>
        <div class="section">
            <img v-if="!trainingCampCoupon.alreadyReceive" @click="showTrainingCampCoupon" class="img1" src="https://s21.lgstatic.com/growth/activity/20220606/1654499065074.png" alt="">
            <img v-else class="img1" src="https://s21.lgstatic.com/growth/activity/20220606/1654499084866.png" alt="">
        </div>
        <div class="section">
            <img class="img2" src="https://s20.lgstatic.com/growth/activity/20220602/1654160597675.png" alt="">
            <div class="icon-box1">
                <img class="re-icon" src="https://s21.lgstatic.com/growth/activity/20220602/1654162560067.png" alt="">
            </div>
            <img class="re-btn"  @click="goOfferForm" src="https://s21.lgstatic.com/growth/activity/20220602/1654159012408.png" alt="">
        </div>
        <div class="section">
            <img class="img3" src="https://s21.lgstatic.com/growth/activity/20220602/1654160620936.png" alt="">
            <div class="icon-box2">
                <img class="re-icon" src="https://s20.lgstatic.com/growth/activity/20220602/1654162538805.png" alt="">
            </div>
            <div class="study-container">
                <img class="study-img study-img-1" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('d68a28c6a455442fbace617b3d27dc54')">
                <img class="study-img study-img-2" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('595408de2a5b418d82cf75f7b19afaa4')">
                <img class="study-img study-img-3" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('b9bbe7ae829f4480bc0d860ebf2b1970')">
                <img class="study-img study-img-4" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('f331871ccf91414896e61eacd84d1429')">
                <img class="study-img study-img-5" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('ec5e7096784f4c12acb30509179da508')">
                <img class="study-img study-img-6" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('ed1890dd539543ef9f01d38018e5d3d0')">
                <img class="study-img study-img-7" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('0279ee5641134bdd9c792ccdf89d319f')">
                <img class="study-img study-img-8" src="https://s20.lgstatic.com/growth/activity/20220602/1654161909374.png"  @click="handleTrainClick('b81a5c0d7dc94c3f88de261065ea56b3')">
            </div>
        </div>
        <div class="section">
            <img class="img4" src="https://s21.lgstatic.com/growth/activity/20220602/1654161031581.png" alt="">
        </div>
        <div class="footer" @click="goOffer">
            <img src="https://s21.lgstatic.com/growth/activity/20220602/1654160656067.png" alt="">
        </div>
        <div v-if="visibleModal" class="recevice-coupon">
            <div class="recevice-coupon-content">
                <div class="recevice-coupon-wrap">
                    <img class="recevice-coupon-img" src="https://s20.lgstatic.com/growth/activity/20220606/1654498422668.png">
                    <div class="subject-list">
                        <div
                            :class="{
                                'subject-item': true,
                                'actived': selectSubject == subject.type
                            }"
                            v-for="subject in subjectList"
                            :key="subject.type"
                            @click="selectedFn(subject.type)"
                        >{{subject.subjectName}}</div>
                    </div>
                </div>
                <div v-if="!selectSubject" class="recevice-coupon-btn">请选择学科</div>
                <div v-else class="recevice-coupon-btn" @click="selected">选好了，抢占优惠</div>
                <div class="close-btn" @click="visibleModal = false"></div>
            </div>
        </div>
        <div v-if="receviceSuccessModal" class="recevice-success">
            <div class="recevice-content">
                <div class="recevice-wrap">
                    <img class="recevice-img" src="https://s20.lgstatic.com/growth/activity/20220328/1648454452724.png">
                    <div class="recevice-txt">优惠券已发送您 {{userLoginAccount}} 账户</div>
                </div>
                <div class="learn-btn" @click="goDetail">查看学科资料</div>
                <div class="later-btn" @click="receviceSuccessModal = false">稍后查看</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { getBigCourseCoupon, receiveBigCourseCoupon, fetchUserInfo } from '../../../service/api'

export default {
    data() {
        return {
            subjectList: [
                { type: 1, subjectName: "Java", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709857214.png',url: 'https://edu.lagou.com/growth/sem/java_architect.html', formId: 'd68a28c6a455442fbace617b3d27dc54' },
                { type: 2, subjectName: "前端", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709872346.png',url: 'https://edu.lagou.com/growth/sem/fe-next.html', formId: '595408de2a5b418d82cf75f7b19afaa4' },
                { type: 3, subjectName: "大数据", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709884836.png',url: 'https://edu.lagou.com/growth/sem/data_enhancement.html', formId: 'b9bbe7ae829f4480bc0d860ebf2b1970' },
                { type: 4, subjectName: "数据分析", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709822126.png',url: 'https://edu.lagou.com/growth/sem/data_analysis.html', formId: 'ec5e7096784f4c12acb30509179da508' },
                { type: 5, subjectName: "测试", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709900045.png',url: 'https://edu.lagou.com/growth/sem/test_engineer.html', formId: '0279ee5641134bdd9c792ccdf89d319f' },
                { type: 6, subjectName: "产品", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709914157.png',url: 'https://edu.lagou.com/growth/sem/pm__enhancement.html', formId: 'f331871ccf91414896e61eacd84d1429' },
                { type: 7, subjectName: "运营", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'b81a5c0d7dc94c3f88de261065ea56b3' },
                { type: 8, subjectName: "商业分析", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'ed1890dd539543ef9f01d38018e5d3d0' }
            ],
            selectSubject: '',
            visibleModal: false,
            trainingCampCoupon: {},
            userInfo: {},
            userLoginAccount: '',
            receviceSuccessModal: false
        }
    },
    created () {
       if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token')) {
          this.initCouponStatus();
        }
    },
    methods: {
        initCouponStatus() {
            getBigCourseCoupon().then(res => {
                if (res.state == 1) {
                    this.trainingCampCoupon = res.content.trainingCampCoupon || {};
                }
            })
            fetchUserInfo().then(res => {
                if (res.state == 1) {
                    this.userInfo = res.content || {};
                }
            })
        },
        selected() {
            const data = {
                couponNo: this.trainingCampCoupon.couponNo,
                subjectId: this.selectSubject
            }
            this.receiveBigCourseCouponFn(data);
        },
        selectedFn(type) {
            this.selectSubject = type;
        },
        handleTrainClick(formId) {
            handleJumpUrl(formId);
        },
        isLogin() {
            return Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token');
        },
        goOffer() {
            window.location.href = 'https://edu.lagou.com/growth/sem/offer.html';
        },
        goOfferForm() {
            handleJumpUrl('96e584784cb94c178ea397db3e409117');
        },
        showTrainingCampCoupon() {
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            this.selectSubject = '';
            this.visibleModal = true;
        },
        receiveBigCourseCouponFn(data) {
            receiveBigCourseCoupon(data).then(res => {
                if (res.state == 1) {
                    this.userLoginAccount =  res.content.userLoginAccount || '';
                    this.receviceSuccessModal = true;
                    this.initCouponStatus();
                } else {
                    this.$message(res.message);
                }
            }).finally(() => {
                this.visibleModal = false;
            })
        },
        goDetail() {
            window.location.href = this.subjectList[this.selectSubject - 1].url;
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    overflow-y: auto;
    background-color: #FF3439;
}
.section {
    position: relative;
    display: flex;
    width: 100%;
    img {
        width: 563PX;
        margin: 0 auto;
        &.header {
            width: 100%;
        }
    }
    .img1 {
        width: 472PX;
    }
    .img2 {
        width: 696PX;
    }
    .img3 {
        width: 610PX;
    }
    .img4 {
        width: 346PX;
    }
    .re-btn {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 291PX;
        height: 60PX;
        transform: translateX(-50%);
    }
    .icon-box1 {
        position: absolute;
        width: 696PX;
        height: 534PX;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        .re-icon {
            position: absolute;
            top: 0;
            right: 52PX;
            width: 111PX;
            height: 61PX;
        }
    }
    .icon-box2 {
        position: absolute;
        width: 610PX;
        height: 534px;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        .re-icon {
            position: absolute;
            top: 0;
            right: 9PX;
            width: 111PX;
            height: 61PX;
        }
    }
    
}
.study-container {
    position: absolute;
    left: 50%;
    top: 0;
    width: 610PX;
    height: 429PX;
    transform: translateX(-50%);
    .study-img {
        position: absolute;
        width: 117PX;
        height: 31PX;
        &-1 {
            top: 210PX;
            left: 26PX;
        }
        &-2 {
            top: 210PX;
            left: 173PX;
        }
        &-3 {
            top: 210PX;
            left: 320PX;
        }
        &-4 {
            top: 210PX;
            left: 467PX;
        }
        &-5 {
            top: 361PX;
            left: 26PX;
        }
        &-6 {
            top: 361PX;
            left: 173PX;
        }
        &-7 {
            top: 361PX;
            left: 320PX;
        }
        &-8 {
            top: 361PX;
            left: 467PX;
        }
    }
}
.recevice-coupon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    .recevice-coupon-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 375PX;
        height: 317PX;
        transform: translateX(-50%) translateY(-50%);
    }
    .recevice-coupon-wrap {
        width: 375PX;
        height: 317PX;
        background-color: #FF3056;
        border-radius: 12PX;
        overflow: hidden;
        .recevice-coupon-img {
            display: block;
            width: 186PX;
            height: 74PX;
            margin: 40PX auto 0;
        }
        .subject-list {
            display: flex;
            width: 350PX;
            height: 135PX;
            padding-top: 25PX;
            margin: 18PX auto 0;
            box-sizing: border-box;
            background-color: #DE111C;
            border-radius: 4PX;
            justify-content: center;
            flex-wrap: wrap;
            .subject-item {
                min-width: 71PX;
                height: 34PX;
                line-height: 34PX;
                padding: 0 9PX;
                box-sizing: border-box;
                font-size: 16PX;
                color: #fff;
                text-align: center;
                margin-bottom: 18PX;
                margin-right: 13PX;
                background-color: #FF7E7E;
                border-radius: 3PX;
                cursor: pointer;
                &:nth-child(4n) {
                    margin-right: 0;
                }
                &.actived {
                    background-color: #AA0000;
                }
            }
        }
    }
    .recevice-coupon-btn {
        position: absolute;
        bottom: -25PX;
        left: 50%;
        width: 239PX;
        height: 50PX;
        line-height: 50PX;
        text-align: center;
        border-radius: 25PX;
        background: linear-gradient(180deg, #FFFFFF 0%, #FFC0C9 100%);
        font-size: 20PX;
        font-weight: bold;
        color: #FF3056;
        transform: translateX(-50%);
    }
    .close-btn {
        position: absolute;
        bottom: -100PX;
        left: 50%;
        width: 45PX;
        height: 45PX;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 45PX 45PX;
        transform: translateX(-50%);
    }
}
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 104PX;
    img {
        width: 100%;
        height: 104PX;
    }
}
.recevice-success {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    z-index: 999;
    .recevice-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 375PX;
        height: 350PX;
        transform: translateX(-50%) translateY(-50%);
        &-2 {
            height: 286PX;
        }
    }
    .recevice-wrap {
        width: 375PX;
        height: 143PX;
        background-color: #FF506D;
        border-radius: 6PX;
        overflow: hidden;
        padding: 0 15PX;
        box-sizing: border-box;
        .recevice-img {
            display: block;
            width: 100PX;
            height: 20PX;
            margin: 46PX auto 0;
            &-1 {
                display: block;
                width: 125PX;
                height: 20PX;
                margin: 38PX auto 0;
            }
        }
        .recevice-txt {
            text-align: center;
            font-size: 13PX;
            color: #fff;
            margin-top: 15PX;
        }
    }
    .recevice-coupon-btn {
        width: 194PX;
        height: 40PX;
        line-height: 40PX;
        text-align: center;
        border-radius: 20PX;
        background: linear-gradient(166deg,  #da0528, #FF506D);
        font-size: 18PX;
        font-weight: bold;
        color: #fff;
        margin: 15PX auto 0;
    }
    .learn-btn {
        width: 194PX;
        height: 40PX;
        background: linear-gradient(166deg, #da0528, #FF506D);
        border-radius: 20PX;
        margin: 20PX auto 0;
        line-height: 40PX;
        text-align: center;
        font-size: 18PX;
        color: #fff;
        font-weight: bold;
    }
    .later-btn {
        margin-top: 16PX;
        text-align: center;
        font-size: 16PX;
        font-style: italic;
        color: #fff;
    }
    .close-btn {
        position: absolute;
        bottom: -70PX;
        left: 50%;
        width: 70PX;
        height: 70PX;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70PX 70PX;
        transform: translateX(-50%);
    }
    .close-btn-2 {
        position: absolute;
        bottom: -110PX;
        left: 50%;
        width: 70PX;
        height: 70PX;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70PX 70PX;
        transform: translateX(-50%);
    }
    .close-btn-3 {
        position: absolute;
        top: -106PX;
        right: 0;
        width: 70PX;
        height: 70PX;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70PX 70PX;
    }
}
</style>
